/* ============================================================
   BIITE — homepage behaviors (no dependencies)
   • Countdown badges     [data-biite-countdown="<epoch seconds>"]
   • Add to cart          [data-biite-add="<variant id>"]
   • Cart toggle          [data-biite-cart-toggle]  (drawer if present, else /cart)
   • Cart count           [data-biite-cart-count]
   • Toast                .biite-toast helper
   ============================================================ */
(function () {
  'use strict';

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'biite-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- countdowns ---------- */
  function fmt(target) {
    var secs = Math.floor((target * 1000 - Date.now()) / 1000);
    if (secs <= 0) return 'LIVE';
    var d = Math.floor(secs / 86400);
    if (d >= 1) return 'IN ' + d + (d === 1 ? ' DAY' : ' DAYS');
    var h = Math.floor(secs / 3600);
    if (h >= 1) return 'IN ' + h + (h === 1 ? ' HOUR' : ' HOURS');
    var m = Math.floor(secs / 60);
    if (m >= 1) return 'IN ' + m + (m === 1 ? ' MIN' : ' MINS');
    return 'IN ' + secs + ' SEC';
  }
  /* drop_when is whatever the team typed for display — "Saturday, August 15,
     12-6pm". Server-side parsing can't be trusted with that (Ruby reads the
     "12" in "12-6pm" as the year 2012), so the badge parses it here:
     ISO dates directly; otherwise month name + day (+ optional year, defaulting
     to the current one) and the first time of a range for the hour. */
  function parseWhen(s) {
    if (!s) return null;
    var l = s.trim().toLowerCase();
    var iso = l.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[t ](\d{1,2})(?::(\d{2}))?)?/);
    if (iso) return Math.floor(new Date(+iso[1], iso[2] - 1, +iso[3], +(iso[4] || 0), +(iso[5] || 0)).getTime() / 1000);
    var MOS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    var m = l.match(/(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+(\d{1,2})(?:st|nd|rd|th)?(?:,?\s+(\d{4}))?/);
    var day, mo, yr;
    if (m) { mo = MOS.indexOf(m[1]); day = +m[2]; yr = m[3] ? +m[3] : new Date().getFullYear(); }
    else {
      m = l.match(/(\d{1,2})(?:st|nd|rd|th)?\s+(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*(?:,?\s+(\d{4}))?/);
      if (!m) return null;
      day = +m[1]; mo = MOS.indexOf(m[2]); yr = m[3] ? +m[3] : new Date().getFullYear();
    }
    var hh = 0, mm = 0;
    var t = l.slice(l.indexOf(m[0]) + m[0].length).match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)?\s*(?:[-–]\s*\d{1,2}(?::\d{2})?\s*(am|pm)?)?/);
    if (t && t[1] && +t[1] < 24) {
      hh = +t[1]; mm = t[2] ? +t[2] : 0;
      var mer = t[3] || t[4]; // "12-6pm": the range's pm applies to its start too
      if (mer === 'pm' && hh < 12) hh += 12;
      if (mer === 'am' && hh === 12) hh = 0;
    }
    return Math.floor(new Date(yr, mo, day, hh, mm).getTime() / 1000);
  }
  function tickCountdowns() {
    var els = document.querySelectorAll('[data-biite-countdown], [data-biite-when]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = parseInt(el.getAttribute('data-biite-countdown'), 10);
      if (isNaN(t) && el.hasAttribute('data-biite-when')) {
        var p = parseWhen(el.getAttribute('data-biite-when'));
        el.removeAttribute('data-biite-when'); // parse once; unreadable text keeps the label
        if (p) { el.setAttribute('data-biite-countdown', p); t = p; }
      }
      if (!isNaN(t)) el.textContent = fmt(t);
    }
  }
  /* Live Drops — a drop that's over is not a live drop. Liquid already keeps
     sold-out products out; here the ones whose drop_when is a day or more
     behind us get pruned too (only this side can read that text — see
     parseWhen). Cards without a readable date are left alone. When nothing
     survives, the whole section goes with them. */
  function pruneLiveDrops() {
    var sec = document.querySelector('.biite-live-drops');
    if (!sec) return;
    var cutoff = Math.floor(Date.now() / 1000) - 86400;
    var live = 0;
    var cards = sec.querySelectorAll('article');
    for (var i = 0; i < cards.length; i++) {
      var badge = cards[i].querySelector('[data-biite-countdown], [data-biite-when]');
      var t = badge ? parseInt(badge.getAttribute('data-biite-countdown'), 10) : NaN;
      if (badge && isNaN(t) && badge.hasAttribute('data-biite-when')) {
        var p = parseWhen(badge.getAttribute('data-biite-when'));
        if (p) t = p;
      }
      if (!isNaN(t) && t < cutoff) { cards[i].style.display = 'none'; continue; }
      live++;
    }
    sec.style.display = live ? '' : 'none';
  }

  /* ---------- cart ---------- */
  function setCount(n) {
    var els = document.querySelectorAll('[data-biite-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].style.display = n > 0 ? 'flex' : 'none';
    }
    var bags = document.querySelectorAll('[data-biite-bag-count]'); // mobile menu "BAG (n)" — always shown
    for (var j = 0; j < bags.length; j++) bags[j].textContent = n;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function renderDrawer(cart) {
    var wrap = document.querySelector('[data-biite-cart-items]');
    if (wrap) {
      wrap.innerHTML = (cart.items || []).map(function (it) {
        return '<div style="display:flex;align-items:center;justify-content:space-between;gap:16px;padding:20px 0;border-bottom:1px solid #ececec;">' +
          '<span style="font-family:\'Newsreader\',Georgia,serif;font-size:1.1rem;line-height:1.3;">' + esc(it.product_title) + (it.quantity > 1 ? ' ×' + it.quantity : '') + '</span>' +
          '<span style="font-family:Inter,sans-serif;font-size:15px;font-weight:500;flex-shrink:0;">' + money(it.final_line_price, cart.currency) + '</span>' +
          '</div>';
      }).join('');
    }
    var empty = document.querySelector('[data-biite-cart-empty]');
    if (empty) empty.style.display = cart.item_count > 0 ? 'none' : 'block';
    var sub = document.querySelector('[data-biite-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price, cart.currency);
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); renderDrawer(c); return c; })
      .catch(function () {});
  }
  function addToCart(id, btn) {
    if (btn) { btn.dataset._label = btn.textContent; btn.textContent = 'ADDING…'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { toast('Added to your bag.'); openDrawer(); })
      .catch(function () { toast('Sorry — could not add that drop.'); })
      .finally(function () { if (btn) { btn.textContent = btn.dataset._label || 'GET THE DROP'; btn.disabled = false; } });
  }

  /* ---------- drawer (present only once the cart section is added) ---------- */
  function drawer() { return document.querySelector('[data-biite-cart-drawer]'); }
  function openDrawer() { var d = drawer(); if (d) { d.setAttribute('data-open', 'true'); document.dispatchEvent(new CustomEvent('biite:cart:open')); } }
  function closeDrawer() { var d = drawer(); if (d) d.setAttribute('data-open', 'false'); }

  /* ---------- wire ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-biite-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-biite-add'), add); return; }
    var toggle = e.target.closest('[data-biite-cart-toggle]');
    if (toggle && drawer()) { e.preventDefault(); openDrawer(); return; } // else: follow href to /cart
    if (e.target.closest('[data-biite-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });

  /* ---------- intro: letter reveal → logo flies home to the header → site
     reveals. When the hero has a video stage ([data-biite-stage]), the film
     waits in its pocket behind the white, already rolling, so the page
     arrives complete — no centre-stage ceremony. */
  function initIntro() {
    var intro = document.querySelector('[data-biite-intro]');
    var stage = document.querySelector('[data-biite-stage]');
    var hero = document.querySelector('[data-biite-hero]');
    var pocket = document.querySelector('[data-biite-pocket]');
    var root = document.documentElement;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var handoff = !!(stage && hero && pocket);

    var stageFilm = stage ? stage.querySelector('[data-biite-film]') : null;
    var stageEnd = stage ? stage.querySelector('[data-biite-endcard]') : null;

    // drop the end card and roll — frame one is already decoded, so it shows instantly
    var playStage = function () {
      if (stage) stage.classList.add('is-rolling');
      if (stageFilm) { try { stageFilm.play(); } catch (e) {} }
    };

    var revealHero = function () {
      if (!hero) return;
      void hero.offsetWidth; // commit current (hidden) state so the rise animates
      hero.classList.add('biite-go');
    };
    var landed = false;
    var land = function () {
      if (landed) return; landed = true;
      if (handoff && stage.parentElement !== pocket) {
        pocket.appendChild(stage);
        stage.classList.remove('is-grow');
        stage.classList.add('is-landed');
        stage.style.transition = 'none'; stage.style.transform = ''; stage.style.opacity = '';
        stage.style.width = ''; stage.style.height = ''; // drop the sizing, fill the pocket
      }
      playStage(); // safety: whatever path got us here, the video ends up playing
      if (stageEnd && stageEnd.parentNode) stageEnd.parentNode.removeChild(stageEnd); // card's work is done
      root.classList.remove('biite-intro-lock');
      revealHero();
      window.__biiteIntroDone = true;   // releases the page's reveals
      try { document.dispatchEvent(new CustomEvent('biite:intro:done')); } catch (e) {}
    };
    var kill = function () { if (intro && intro.parentNode) intro.parentNode.removeChild(intro); };

    // no ceremony (no intro on this page, repeat visit, or reduced motion):
    // video straight to its pocket, hero rises immediately
    if (!intro || reduce || window.__biiteIntroSeen) { kill(); land(); return; }

    // the CSS bail dissolves the overlay when this script was slow to arrive
    // (slow mobile) — never bring the white back over an already-visible page
    try { if (getComputedStyle(intro).visibility === 'hidden') { kill(); land(); return; } } catch (e) {}
    intro.classList.add('is-live'); // cancels the CSS bail; JS owns the exit now

    root.classList.add('biite-intro-lock');
    var big = intro.querySelector('[data-biite-intro-logo]');
    var headerLogo = document.querySelector('[data-biite-header-logo]');
    var lifted = false;
    var lift = function () {
      if (lifted) return; lifted = true;
      intro.classList.add('is-lifting');
      setTimeout(kill, 520);
    };
    var flyLogo = function () {
      var b = big && big.getBoundingClientRect();
      var h = headerLogo && headerLogo.getBoundingClientRect();
      if (!(b && h && b.width && h.width)) return false;
      var scale = h.width / b.width;
      var dx = (h.left + h.width / 2) - (b.left + b.width / 2);
      var dy = (h.top + h.height / 2) - (b.top + b.height / 2);
      big.style.transition = 'transform .6s cubic-bezier(.645,.045,.355,1)';
      big.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
      return true;
    };

    // Warm the film behind the white: a cold play() spins the decoder up first,
    // which would leave the pocket showing nothing for a beat as the curtain
    // lifts. Roll it briefly now and rewind, so the reveal's play() starts
    // instantly from the top. Skip the rewind if the reveal already happened.
    if (stageFilm) (function warmFilm() {
      var go = function () {
        if (landed) return;
        var settle = function () {
          if (landed) return;
          try { stageFilm.pause(); stageFilm.currentTime = 0; } catch (e) {}
        };
        var pr;
        try { pr = stageFilm.play(); } catch (e) { return; }
        if (pr && pr.then) pr.then(settle).catch(function () {});
        else setTimeout(settle, 60);
      };
      if (stageFilm.readyState >= 3) go();
      else stageFilm.addEventListener('canplay', go, { once: true });
    })();

    // classic intro: letters → logo flies home to the header → lift → reveal
    var done = false;
    var finish = function () { if (done) return; done = true; lift(); land(); };
    var safety = setTimeout(finish, 3200); // never trap the site
    setTimeout(function () {
      if (flyLogo()) setTimeout(function () { clearTimeout(safety); finish(); }, 470);
      else { clearTimeout(safety); finish(); }
    }, 720);
  }

  /* ---------- headings: characters rise from behind the line.
     Ported from the live site, which does this with GSAP SplitText
     (lines masked, chars yPercent 100 → 0, 0.6s, 0.03s stagger, power3.out).
     Rebuilt here in plain CSS/JS so the theme keeps no GSAP dependency. ---------- */
  // `start` keeps the stagger running across a multi-line heading, so the cascade
  // carries from one line into the next instead of restarting (as on the live site)
  function splitToChars(el, start) {
    if (!el || el.querySelector('.biite-char')) return false; // already split
    var text = el.textContent;
    if (!text.replace(/\s/g, '')) return false;
    el.textContent = '';
    el.classList.add('biite-split');
    var line = document.createElement('span');
    line.className = 'biite-line';
    var i = start || 0;
    text.trim().split(/(\s+)/).forEach(function (token) {
      if (/^\s+$/.test(token)) { line.appendChild(document.createTextNode(' ')); return; }
      var word = document.createElement('span');   // keep words intact so they never break mid-wrap
      word.className = 'biite-word';
      token.split('').forEach(function (ch) {
        var s = document.createElement('span');
        s.className = 'biite-char';
        s.textContent = ch;
        s.style.setProperty('--c', i++);
        word.appendChild(s);
      });
      line.appendChild(word);
    });
    el.appendChild(line);
    return i; // next stagger index
  }

  function initTextReveal() {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // the display headings only — uppercase, no descenders to clip against the mask
    var split = [];
    var title = document.querySelector('.biite-hero__title');
    if (title && !title.querySelector('img')) {
      var n = 0;
      [].forEach.call(title.children, function (span) {
        var next = splitToChars(span, n);
        if (next !== false) { n = next; split.push(span); }
      });
    }
    ['.biite-live-drops', '.biite-past-drops'].forEach(function (sel) {
      var h = document.querySelector(sel + ' h2');
      if (h && splitToChars(h, 0) !== false) split.push(h);
    });
    if (!split.length) return;

    // the hero's chars are driven by the handoff (.biite-go); the rest on scroll
    var onScroll = split.filter(function (el) { return !el.closest('.biite-hero'); });
    if (!onScroll.length) return;
    if (!('IntersectionObserver' in window)) {
      onScroll.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    whenIntroDone(function () {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
      onScroll.forEach(function (el) { io.observe(el); });
      setTimeout(function () { onScroll.forEach(function (el) { el.classList.add('is-in'); }); }, 5000); // safety
    });
  }

  /* ---------- one signal for "the intro has finished" ----------
     Reveals wait on this so the page isn't sitting there fully formed behind the
     white overlay, ready to be exposed the moment it lifts. Flag + event, because
     the reveals are wired both before and after initIntro runs. */
  function whenIntroDone(fn) {
    var ran = false;
    var go = function () { if (ran) return; ran = true; fn(); };
    if (window.__biiteIntroDone) { go(); return; }
    document.addEventListener('biite:intro:done', go, { once: true });
    setTimeout(go, 8000); // never strand the page
  }

  /* ---------- live drops: drop the lead column so the featured image's centre sits
     on the bottom edge of the first stacked card's button. The offset can't be a
     fixed value — it depends on the stacked card's title wrapping to one line or
     two — so it is measured. The heading rides down with it, since both live in
     the same column. ---------- */
  function alignDropsLead() {
    var lead = document.querySelector('.biite-drops__lead');
    var stack = document.querySelector('.biite-drops__stack');
    if (!lead || !stack) return;
    var frame = lead.querySelector('article > a');            // the featured image box
    var h2 = lead.querySelector('.biite-drops__title');
    var card = stack.querySelector('article');
    var cta = card && card.querySelector('.biite-getdrop');
    if (!frame || !cta || !h2) return;

    var PAD = 30;   // extra breathing room under the heading

    var apply = function () {
      lead.style.marginTop = '';                              // always measure from clean
      lead.style.rowGap = '';
      // Only meaningful while the two columns share a row. The grid wraps well above
      // the phone breakpoint (lead 520 + stack 360 + gap outgrows the content box by
      // ~1024px), and once the stack drops below, the measurement runs away.
      if (Math.abs(lead.getBoundingClientRect().top - stack.getBoundingClientRect().top) > 2) return;

      // Everything below is measured from the stack column, so none of it is
      // affected by the offset we're about to set — no need to iterate.
      var top = stack.getBoundingClientRect().top;            // top of the right-hand image
      var imgH = frame.getBoundingClientRect().height;
      var headH = h2.getBoundingClientRect().height;
      var leftTop = cta.getBoundingClientRect().bottom - imgH / 2;  // keeps the image centred on the button
      // Centre the heading in the space between the two image tops, then lift it by
      // PAD so the gap below it is the larger one.
      var half = (leftTop - top - headH) / 2;
      var mt = half - PAD, gap = half + PAD;
      if (mt < 0) { gap += mt; mt = 0; }                      // never pull it above the grid
      if (gap < 0) return;
      lead.style.marginTop = Math.round(mt) + 'px';
      lead.style.rowGap = Math.round(gap) + 'px';
    };

    apply();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply); // type metrics settle
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
  }

  /* ---------- scroll reveal: content rises in as sections enter view ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var SEL = 'h1, h2, blockquote, p, form, article, figure, img';
    var secs = document.querySelectorAll('.biite-hero, .biite-live-drops, .biite-past-drops, .biite-apparel, .biite-collab, .biite-press, .biite-agency, .biite-footer');
    var items = [];
    for (var s = 0; s < secs.length; s++) {
      var sec = secs[s];
      if (sec.hasAttribute('data-biite-handoff')) continue; // hero runs its own reveal (via the intro handoff)
      var found = [].slice.call(sec.querySelectorAll(SEL));
      var targets = [];
      for (var i = 0; i < found.length; i++) {
        var el = found[i];
        if (el.tagName === 'IMG') {
          if (getComputedStyle(el).position === 'absolute') continue; // mosaic tiles
          if (el.closest('article')) continue;                        // drop-card imgs (card reveals as one)
          if (el.classList.contains('biite-zoom')) el = el.parentElement; // framed image → reveal its frame
        }
        var anc = el.parentElement, nested = false;
        while (anc && anc !== sec) { if (targets.indexOf(anc) !== -1) { nested = true; break; } anc = anc.parentElement; }
        if (nested || targets.indexOf(el) !== -1) continue;
        targets.push(el);
      }
      if (sec.classList.contains('biite-past-drops')) {
        var grid = sec.querySelector('[style*="aspect-ratio"]');
        if (grid && targets.indexOf(grid) === -1) targets.push(grid);
      }
      for (var j = 0; j < targets.length; j++) {
        targets[j].style.setProperty('--r', j % 6);
        targets[j].classList.add('biite-reveal');
        items.push(targets[j]);
      }
    }
    // hidden from the first paint above; only start watching once the intro is done
    whenIntroDone(function () {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.04 });
      items.forEach(function (el) { io.observe(el); });
      setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 4500); // safety
    });
  }

  /* ---------- drop page: cycle the main photos automatically ----------
     Drives the theme's own media gallery by activating each thumbnail in turn,
     so it stays in sync with the gallery's normal behaviour. Pauses on hover,
     on any interaction, and while the tab is hidden. */
  function initDropGallery() {
    // NOTE: deliberately NOT gated on prefers-reduced-motion. The cycling is a
    // client requirement, and the guard meant anyone with the OS setting on
    // (several of the reviewers, evidently) saw a frozen gallery and reported
    // it broken. A slide swap every ~4s is mild; the intro keeps its guard.

    // This theme does NOT use Dawn's <media-gallery> on the product page — that
    // snippet is dead code here. main-product.liquid renders 'product-slider',
    // which is a Swiper (#s-hero-product__swiper) with its own nav buttons and a
    // thumbnail strip. Drive that instead.
    var el = document.querySelector('#s-hero-product__swiper');
    if (!el) return;
    if (el.querySelectorAll('.swiper-slide').length < 2) return; // one photo — nothing to cycle

    var DWELL = 4200;
    var timer = null, stopped = false, onScreen = true, hovered = false;

    // Swiper is built without loop:true, so slideNext() stalls on the last slide —
    // wrap back to the start by hand. Falls back to the theme's own next button if
    // the instance isn't exposed.
    var advance = function () {
      var sw = el.swiper;
      if (sw && typeof sw.slideNext === 'function') {
        if (sw.isEnd) sw.slideTo(0); else sw.slideNext();
        return;
      }
      var next = document.querySelector('.main-slider-button-next');
      if (next) next.click();
    };

    var RESUME = 8000;   // idle time after a user takes over before it picks back up
    var idle = null;

    var step = function () { if (!stopped && !document.hidden && onScreen) { try { advance(); } catch (e) {} } };
    var start = function () { if (!timer && !stopped && onScreen && !hovered) timer = setInterval(step, DWELL); };
    var pause = function () { if (timer) { clearInterval(timer); timer = null; } };
    // Yield to a real interaction, then pick the reel back up once they've been idle
    // — stopping for good meant one stray click killed it for the whole visit.
    // Only a *real* one: our own synthetic clicks on the nav button would otherwise
    // pause the reel the first time it advanced.
    var userTook = function (e) {
      if (e && e.isTrusted === false) return;
      stopped = true; pause();
      clearTimeout(idle);
      idle = setTimeout(function () { stopped = false; start(); }, RESUME);
    };

    el.addEventListener('mouseenter', function () { hovered = true; pause(); });
    el.addEventListener('mouseleave', function () { hovered = false; start(); });
    el.addEventListener('click', userTook);
    el.addEventListener('touchstart', userTook, { passive: true });
    ['#s-hero-product__swiper-thumbs', '.main-slider-button-next', '.main-slider-button-prev']
      .forEach(function (sel) { var n = document.querySelector(sel); if (n) n.addEventListener('click', userTook); });
    document.addEventListener('visibilitychange', function () { document.hidden ? pause() : start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        onScreen ? start() : pause();
      }, { threshold: 0.25 }).observe(el);
    }

    // biite.js is loaded before main.js, so the Swiper doesn't exist yet — wait for
    // it rather than starting against a slider that can't move.
    var tries = 0;
    (function waitForSwiper() {
      if (el.swiper) { start(); return; }
      if (++tries < 40) { setTimeout(waitForSwiper, 100); return; } // ~4s grace
      start(); // fall back to clicking the nav button
    })();
  }

  /* ---------- mobile menu (hamburger → full-screen overlay) ---------- */
  function initMobileMenu() {
    var menu = document.querySelector('[data-biite-menu]');
    if (!menu) return;
    var root = document.documentElement;
    function open() { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); root.classList.add('biite-menu-lock'); }
    function closeMenu() { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); root.classList.remove('biite-menu-lock'); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-biite-menu-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-biite-menu-close]')) { e.preventDefault(); closeMenu(); return; }
      if (e.target.closest('[data-biite-menu] a')) { closeMenu(); } // nav/account/contact/bag → close (cart handler still opens the drawer)
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeMenu(); });
  }

  /* ---------- host layout: clear the theme's fixed, pointer-events:none header ---------- */
  function clearFixedHeader() {
    var wrap = document.getElementById('header-my-wrap'); // only in the host theme's fixed-overlay layout
    var header = document.querySelector('.biite-header');
    var main = document.getElementById('MainContent');
    if (!wrap || !header || !main) return;
    var apply = function () { main.style.paddingTop = Math.round(header.getBoundingClientRect().height) + 'px'; };
    apply();
    /* flag the shell: page tops that only existed to clear the OLD fixed
       header (e.g. .s-drops) collapse to normal spacing via biite.css */
    document.documentElement.classList.add('biite-header-cleared');
    window.addEventListener('resize', apply);
    if (window.ResizeObserver) { try { new ResizeObserver(apply).observe(header); } catch (e) {} }
  }

  /* Autoplay can be refused outright (iPhone Low Power Mode, data saver) — the
     films then hold on their poster frame, and iOS's own play glyph is often
     buried under our overlays. Any first touch/click is a user gesture, which
     re-arms playback: retry every paused Biite film once per gesture type. */
  function initVideoResume() {
    var kick = function () {
      [].forEach.call(document.querySelectorAll('.biite-stage video, .biite-wwu video, video[autoplay][muted]'), function (v) {
        if (v.paused) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
      });
    };
    ['touchstart', 'click'].forEach(function (t) {
      try { document.addEventListener(t, kick, { once: true, passive: true }); }
      catch (e) { document.addEventListener(t, kick); }
    });
  }

  function init() {
    var run = function (fn) { try { fn(); } catch (e) { if (window.console) console.warn('[biite]', e); } };
    run(initMobileMenu); // wire the menu FIRST so a later failure can never block it
    run(initVideoResume);
    run(clearFixedHeader);
    run(alignDropsLead);
    run(initTextReveal); // split headings before initIntro can reveal the hero
    run(initIntro);
    run(initReveal);
    run(initDropGallery);
    run(tickCountdowns);
    try { setInterval(tickCountdowns, 1000); } catch (e) {}
    run(pruneLiveDrops);
    try { setInterval(pruneLiveDrops, 60000); } catch (e) {}
    run(refreshCart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.Biite = { toast: toast, refreshCart: refreshCart, addToCart: addToCart };
})();
